import $ from "jquery";
import Swiper, {
  Autoplay,
  Controller,
  EffectCoverflow,
  Lazy,
  Navigation,
} from "swiper";

$(function () {
  if ($(".js-division").length) {
    const swiperDivision = new Swiper(".js-division", {
      modules: [Autoplay, Navigation],
      //** Optional parameters **//
      loop: true,
      slidesPerView: 1,
      speed: 1200,
      spaceBetween: 12,
      autoplay: {
        delay: 6500,
      },

      // Navigation
      navigation: {
        nextEl: ".js-division-btn__next",
        prevEl: ".js-division-btn__prev",
      },
    });
  }

  if ($(".js-brands__image").length) {
    const swiperBrandsImage = new Swiper(".js-brands__image", {
      modules: [Controller, EffectCoverflow],
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      slideActiveClass: "slide--active",

      breakpoints: {
        768: {
          slidesPerView: 3,
          loopedSlides: 3,
        },
        1280: {
          slidesPerView: 3,
          allowTouchMove: false,
        },
      },
    });

    const swiperBrandsContent = new Swiper(".js-brands__content", {
      modules: [Controller, Navigation],
      loop: true,
      slidesPerView: 1,

      breakpoints: {
        768: {
          loopedSlides: 3,
        },
        1280: {
          loopedSlides: 3,
          allowTouchMove: false,
        },
      },

      // Navigation
      navigation: {
        nextEl: ".js-brands-btn__next",
        prevEl: ".js-brands-btn__prev",
      },
    });

    swiperBrandsContent.controller.control = swiperBrandsImage;
  }

  if ($(".js-news").length) {
    const swiperNews = new Swiper(".js-news", {
      modules: [Navigation, Lazy],

      loop: true,
      slidesPerView: 1,

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },

      navigation: {
        nextEl: ".js-news-btn__next",
        prevEl: ".js-news-btn__prev",
      },
    });
  }

  if ($(".js-latest-news").length) {
    let swiperLatestNews;

    function disableSwiper() {
      if (window.innerWidth >= 1280) {
        if (swiperLatestNews && swiperLatestNews.destroy) {
          swiperLatestNews.destroy(true, true); // Destroy Swiper and leave the slides intact
        }
      } else {
        if (!swiperLatestNews || !swiperLatestNews.initialized) {
          // Create Swiper only if it's not defined or not initialized
          swiperLatestNews = new Swiper(".js-latest-news", {
            modules: [Navigation, Lazy],
            //** Optional parameters **//
            loop: true,
            slidesPerView: 1,

            breakpoints: {
              768: {
                slidesPerView: 2,
              },
            },

            navigation: {
              nextEl: ".js-latest-news-btn__next",
              prevEl: ".js-latest-news-btn__prev",
            },
          });
        }
      }
    }

    // Listen for window resize events
    window.addEventListener("resize", disableSwiper);

    // Call the function on initial load
    disableSwiper();
  }

  if ($(".js-resources").length) {
    const resourcesCarousels = document.querySelectorAll(".resources-carousel");
    let globalIndex = 1;

    resourcesCarousels.forEach((resourcesCarousel) => {
      const swiperNavigation =
        resourcesCarousel.querySelector(".js-resources-nav");
      const swiperResources =
        resourcesCarousel.querySelectorAll(".js-resources");

      swiperResources.forEach((item) => {
        let breakpoints = {};

        if (item.classList.contains("js-resources--shareholders")) {
          breakpoints = {
            640: { slidesPerView: 2, slidesPerGroup: 2 },
            1024: { slidesPerView: 4, slidesPerGroup: 4 },
          };
        } else {
          breakpoints = {
            640: { slidesPerView: 2, spaceBetween: 16 },
            1024: { slidesPerView: 4, spaceBetween: 28 },
          };
        }

        const swiperInstance = new Swiper(item, {
          modules: [Navigation, Lazy],
          loop: true,
          slidesPerView: 1,
          breakpoints,
          navigation: {
            nextEl: `.js-resources-btn__next-${globalIndex}`,
            prevEl: `.js-resources-btn__prev-${globalIndex}`,
          },
        });

        const currentWindowWidth = window.innerWidth;

        const numberOfNonDuplicateSlides = Array.from(
          swiperInstance.slides
        ).filter(
          (slide) => !slide.classList.contains("swiper-slide-duplicate")
        ).length;

        const breakpointThreshold = [640, 1024];
        const breakpointSlides = [2, 4];

        for (let i = 0; i < breakpointThreshold.length; i++) {
          // Check if the window width is greater than or equal to the current breakpoint
          // and the number of non-duplicate slides is less than or equal to the corresponding breakpoint
          if (
            currentWindowWidth >= breakpointThreshold[i] &&
            numberOfNonDuplicateSlides <= breakpointSlides[i]
          ) {
            if (swiperNavigation) swiperNavigation.style.display = "none";

            swiperInstance.destroy();

            const wrapperElement = item.querySelector(".swiper-wrapper");
            if (wrapperElement) {
              wrapperElement.classList.add(
                "grid",
                "grid-cols-2",
                "gap-7",
                "lg:grid-cols-4"
              );
            }
          }
        }

        globalIndex++;
      });
    });
  }
});
